export default __webpack_public_path__ + "static/media/phylactere_la_vie.c950fadd.png";